import React, { Fragment, useEffect } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";
import Loader from "pages/_components/Loader";
import Notification from "pages/_components/Notification";
import { statusTagColor } from "util/debin";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import { Col, Row } from "react-bootstrap";
import { bool } from "prop-types";
import DataRecurrentDebin from "./_components/DataRecurrentDebin";
import InfoTag from "../_components/InfoTag";

const DetailDebin = ({ isDesktop }) => {
    const { fetching, debinRecurrency, seller } = useSelector((state) => state.debin);
    const { accounts } = useSelector((state) => state.accounts);
    const { id } = useParams();
    const dispatch = useDispatch();
    const recurrency = debinRecurrency.find((object) => object.id === id);
    const account = accounts?.find((object) => object?.cbu?.substring(9) === recurrency?.buyer?.cbu);
    useEffect(() => {
        if (debinRecurrency?.length > 0) {
            dispatch(debinActions.debinSeller(recurrency?.seller?.documentNumber));
        }
    }, [debinRecurrency]);
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    if (fetching) {
        return <Loader />;
    }

    const message = () => {
        let messageText;
        if (recurrency?.status === "INACTIVA") {
            messageText = "PAUSADO";
        }
        if (recurrency?.status === "ACTIVA") {
            messageText = "ACTIVO";
        }
        if (recurrency?.status === "INACTIVA DEFINITIVA") {
            messageText = "ELIMINADO";
        }
        return messageText;
    };

    const State = () => <InfoTag type="info" message={message()} tagBackground={statusTagColor(recurrency?.status)} />;
    const debitAccountMask = `****${account?.shortLabel?.substring(1)}`;

    const buttons = () => (
        <>
            {recurrency?.status === "ACTIVA" && (
                <div>
                    <Row className="pb-9">
                        <Col xs={12} md={4} mdOffset={2}>
                            <Button
                                className="btn btn-outline"
                                label="eliminate.debin"
                                onClick={() => {
                                    dispatch(
                                        debinActions.setRecurrencyDebinAction({
                                            action: "ELIMINAR",
                                            debin: recurrency,
                                        }),
                                    );
                                    dispatch(push("/debinPayments/action/action"));
                                }}
                            />
                        </Col>
                        <Col xs={12} md={4} mdOffset={6} className="grid-row-end">
                            <Button
                                className="btn btn-primary"
                                label="pause.debin"
                                onClick={() => {
                                    dispatch(
                                        debinActions.setRecurrencyDebinAction({
                                            action: "PAUSAR",
                                            debin: recurrency,
                                        }),
                                    );
                                    dispatch(push("/debinPayments/action/action"));
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            )}
            {recurrency?.status === "INACTIVA" && (
                <div>
                    <Row className="pb-9">
                        <Col xs={12} md={4} mdOffset={2}>
                            <Button
                                className="btn btn-outline"
                                label="eliminate.debin"
                                onClick={() => {
                                    dispatch(
                                        debinActions.setRecurrencyDebinAction({
                                            action: "ELIMINAR",
                                            debin: recurrency,
                                        }),
                                    );
                                    dispatch(push("/debinPayments/action/action"));
                                }}
                            />
                        </Col>
                        <Col xs={12} md={4} mdOffset={6} className="grid-row-end">
                            <Button
                                className="btn btn-primary"
                                label="activate.debin"
                                onClick={() => {
                                    dispatch(
                                        debinActions.setRecurrencyDebinAction({
                                            action: "ACTIVAR",
                                            debin: recurrency,
                                        }),
                                    );
                                    dispatch(push("/debinPayments/action/action"));
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            )}
            {recurrency?.status === "INACTIVA DEFINITIVA" && (
                <Row className="pb-9">
                    <Col xs={12} md={4} mdOffset={4}>
                        <Button
                            className="btn btn-primary"
                            label="debin.adhere.again"
                            onClick={() => {
                                dispatch(push("/debinPayments/AddRecurence"));
                            }}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
    return (
        <Fragment>
            <Notification scopeToShow="debinPayments" />
            <ResponsiveHeader
                id="debin.recurence.detail.title"
                backLinkTo="/debinPayments"
                infoComponents={
                    isDesktop && (
                        <div className="pl-4">
                            <State />
                        </div>
                    )
                }
            />
            <MainContainer showLoader={fetching}>
                {isDesktop && (
                    <div className="idDebin">
                        <CustomData
                            titleText="recurrent.debin.id"
                            titleTextType="I18N"
                            valueText={<CustomText className="ml-4" textType="data-label" text={`${recurrency?.id}`} />}
                        />
                    </div>
                )}

                <DataRecurrentDebin
                    date={recurrency?.creationDate}
                    debitAccount={debitAccountMask}
                    seller={seller?.titular}
                    sellerCuit={seller?.cuit}
                    service={recurrency?.debin?.lending}
                    reference={recurrency?.debin?.reference}
                    concept={recurrency?.debin?.concept}
                    description={recurrency?.debin?.detail}
                    recurrency={recurrency?.id}
                    isDesktop={isDesktop}
                />
                {buttons()}
            </MainContainer>
        </Fragment>
    );
};

DetailDebin.propTypes = {
    isDesktop: bool.isRequired,
};

export default DetailDebin;
